/**
 * Format THC/CBD pourcentage
 */
export function formatTotalPercentage(value: any) {
  if (value === undefined || value === null) return null;

  return value > 0 && value < 1
    ? `${value.toFixed(2)}%`
    : `${Math.round(value)}%`;
}

/**
 * Get most prominent secondary cannabinoid of a oil
 */
export function getSecondaryCannabinoidIngredient(coaReport) {
  const ingredients = coaReport.ingredients || [];

  // Filter out objects with type 'terpene' or name containing 'THC'
  const filteredIngredients = ingredients.filter(
    obj => obj.type === "cannabioid" && !obj.name.toUpperCase().includes("THC")
  );

  // Sort the remaining objects by percentage in descending order
  const sortedIngredients = filteredIngredients.sort(
    (a, b) => b.percentage - a.percentage
  );

  // Return the second object with the highest percentage, if it exists
  const secondaryCannabinoid = sortedIngredients[0] || null;

  if (!secondaryCannabinoid) {
    return {
      name: "CBD",
      percentage: coaReport.cbdTotalPercent || 0
    };
  }

  return secondaryCannabinoid;
}
